import type { LorsCopy } from "./translations";

const LorsRegistration = ({ copy }: { copy: LorsCopy }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      id="registration"
      className="py-20"
      style={{ backgroundColor: "hsl(210 24% 20%)", color: "hsl(0 0% 100%)" }}
    >
      <div className="container max-w-4xl mx-auto px-6 text-center">
        <h2
          className="lors-headline text-3xl md:text-4xl mb-4"
          style={{ color: "hsl(0 0% 100%)" }}
        >
          {copy.registrationTitle}
        </h2>
        <p className="text-lg mb-8" style={{ color: "hsl(0 0% 100% / 0.8)" }}>
          {copy.registrationSub}
        </p>

        <button
          onClick={scrollToTop}
          className="font-semibold text-lg px-10 py-4 rounded-lg shadow-md transition-colors hover:opacity-90"
          style={{
            backgroundColor: "hsl(34 23% 72%)",
            color: "hsl(210 24% 20%)",
            fontFamily: "'Montserrat', system-ui, sans-serif",
          }}
        >
          {copy.registrationCta}
        </button>

        <p className="text-sm mt-8 whitespace-nowrap" style={{ color: "hsl(0 0% 100% / 0.6)" }}>
          {copy.registrationFoot}
        </p>
      </div>
    </section>
  );
};

export default LorsRegistration;
